var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    _vm._g(
      _vm._b(
        {
          class: _vm.customClass,
          staticStyle: {
            position: "relative",
            "font-family": "GeneralSans",
            "font-weight": "600"
          },
          style: {
            minWidth: _vm.minWidth
          },
          attrs: { type: "button", disabled: _vm.loading || _vm.disabled }
        },
        "button",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [
      _vm.loading
        ? _c(
            "div",
            {
              staticStyle: {
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate3d(-50%, -50%, 0)"
              }
            },
            [
              _c("v-progress-circular", {
                attrs: { indeterminate: "", size: "24" }
              })
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        {
          class: [_vm.contentClass, { "opacity-0": _vm.loading }],
          staticStyle: { gap: "8px", "min-width": "fit-content" }
        },
        [_vm._t("default")],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }